import * as React from "react";
import ModalAction, { ModalActionProps } from "./ModalAction";

export default class ModalDelete extends React.Component<ModalActionProps> {
  render() {
    return (
      <ModalAction
        title={this.props.title}
        cancelButtonLabel={this.props.cancelButtonLabel}
        actionButtonLabel={
          this.props.actionButtonLabel ? this.props.actionButtonLabel : i18n["Global.Delete"]
        }
        cancel={this.props.cancel}
        action={this.props.action}
        dialogClass={"v-flex delete-dialog"}
        actionButtonClass={"danger"}
        iconElement={"ic_trash"}
        hideCloseIcon={true}
      >
        {this.props.children}
      </ModalAction>
    );
  }
}
